import api from "../api/axios";
import {
    Match,
  MatchResult,
  ProgressSingleEliminationRound,
  UpdateSingleEliminationScorePayload,
  UpdateDoubleEliminationScorePayload,
  UpdateDoubleEliminationScoreResponse,
  ProgressDoubleEliminationRoundPayload,
  ProgressWinnersBracketResponse,
  ProgressLosersBracketResponse,
  CompleteDoubleEliminationFinalResponse,
} from "./bracket.types";
import { Tournament } from "./tournament.types";

export const shuffleTournamentBracket = async (
  tournamentId: string,
): Promise<Tournament> => {
  try {
    const response = await api.post(`/tournaments/shuffle/${tournamentId}`);
    return response.data.tournament;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error shuffling tournament bracket",
    );
  }
};

export const updateSingleEliminationScore = async (
  tournamentId: string,
  payload: UpdateSingleEliminationScorePayload,
): Promise<Match> => {
  try {
    const response = await api.put(
      `/bracket/single-elimination/${tournamentId}/score`,
      payload,
    );  
    return response.data.match;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error shuffling tournament bracket",
    );
  }
};

export const progressSingleEliminationScore = async (
  tournamentId: string,
  payload: ProgressSingleEliminationRound,
): Promise<MatchResult[]> => {
  try {
    const response = await api.post(
      `/bracket/single-elimination/${tournamentId}/progress`,
      payload,
    );
    return response.data.matches;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error shuffling tournament bracket",
    );
  }
};

export const deleteRound = async (
  tournamentId: string,
  roundName: string,
): Promise<void> => {
  try {
    await api.delete(
      `/bracket/single-elimination/${tournamentId}/round/${roundName}`,
    );
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error deleting round",
    );
  }
};

export const updateDoubleEliminationScore = async (
  tournamentId: string,
  payload: UpdateDoubleEliminationScorePayload,
): Promise<UpdateDoubleEliminationScoreResponse> => {
  try {
    const response = await api.put(
      `/bracket/double-elimination/${tournamentId}/score`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error updating double elimination score",
    );
  }
};

export const progressDoubleEliminationWinnersBracket = async (
  tournamentId: string,
  payload: ProgressDoubleEliminationRoundPayload,
): Promise<ProgressWinnersBracketResponse> => {
  try {
    const response = await api.post(
      `/bracket/double-elimination/${tournamentId}/progress/winners`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error progressing winners bracket",
    );
  }
};

export const progressDoubleEliminationLosersBracket = async (
  tournamentId: string,
  payload: ProgressDoubleEliminationRoundPayload,
): Promise<ProgressLosersBracketResponse> => {
  try {
    const response = await api.post(
      `/bracket/double-elimination/${tournamentId}/progress/losers`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error progressing losers bracket",
    );
  }
};

export const completeDoubleEliminationFinal = async (
  tournamentId: string,
): Promise<CompleteDoubleEliminationFinalResponse> => {
  try {
    const response = await api.post(
      `/bracket/double-elimination/${tournamentId}/final/complete`,
      {},
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.error ||
        error.message ||
        "Error completing final match",
    );
  }
};
